import { useSelector } from "react-redux";
import _ from "lodash";
import { useMemo } from "react";

export const usePartyOrder = () => {
  const voteShareData = useSelector((state) => state.voteShare.value);
  const region = useSelector((state) => state.region.value);

  const orderedParties = useMemo(() => {
    return _.chain(voteShareData)
      .filter((datum) => !!datum.party)
      .filter((datum) => region === datum.region)
      .sortBy((datum) => {
        if (datum.median === "NA") return 999;
        return parseFloat(datum.median);
      })
      .reverse()
      .map("party")
      .uniq()
      .value();
  });

  return {
    orderedParties,
  };
};
